<template>
  <nuttrema-layout-content>
    <template slot="header">
      <persons-standard-header
        :edit.sync="edit"
        :meta="meta"
        :showEdit="false"
        :PersonDetails="PersonDetails">
      </persons-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="PersonDetails.fetching || PersonPrograms.fetching"></nuttrema-loader>
      <assigned-programs-list
         v-else
        :meta="meta"
        :state="_get(PersonPrograms, 'data')">
      </assigned-programs-list>
    </template>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import PersonsStandardHeader from 'components/pages/professional/persons/participants/shared/blocks/cmpt-persons-standard-header';

import AssignedProgramsList from './cmpt-assigned-programs-list';

export default {
  name: 'page-participant-assigned-programs',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
    PersonPrograms() {
      return this.$store.getters.PersonPrograms(this.id);
    },
  },
  components: {
    AssignedProgramsList,
    NuttremaLayoutContent,
    PersonsStandardHeader,
  },
  created() {
    this.$store.dispatch('GetPersonPrograms', { id: this.id, type: this.type });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonPrograms', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/assigned-programs/page-participant-assigned-programs.vue